import {lazy} from 'react';

export const SpecialistsFindAsync = lazy(() =>
    import('./SpecialistsFind')
);
